import React from 'react';
import { ArrowRightIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { company, services } from '../data/site';
import { directQuoteMailto } from '../utils/contact';
import { BrandGlyph } from './BrandGlyph';
import { Reveal } from './Reveal';
import { ButtonLink } from './ui/Button';
export function CtaBanner() {
  return <section aria-labelledby="cta-heading" className="relative isolate overflow-hidden bg-charcoal-900" data-id="element-94" data-mp="yo88aw5rasct">
      <img src={services[0].image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" loading="lazy" data-id="element-95" data-mp="1w8ky79hdtotj" />
      <div className="absolute inset-0 bg-charcoal-900/85" aria-hidden="true" data-id="element-96" data-mp="1man0zwhjohos" />
      <BrandGlyph className="pointer-events-none absolute -bottom-16 -left-20 w-[460px] text-white/[0.06]" data-id="element-97" data-mp="1hclibco16kdu" />

      <div className="relative mx-auto grid max-w-container gap-12 px-5 py-20 lg:grid-cols-[1.15fr_1fr] lg:gap-16 lg:py-28 lg:px-8" data-id="element-98" data-mp="ayvxxsyp0e8x">
        <Reveal data-id="element-99" data-mp="1b8t0o3ixsowt">
          <p className="text-[13px] font-bold uppercase tracking-[0.16em] text-cobalt-300" data-id="element-100" data-mp="1b89h6idn1sgo">
            Talk to CoPro Services
          </p>
          <h2 id="cta-heading" className="mt-5 text-[2.25rem] font-extrabold leading-[1.06] tracking-tight text-white sm:text-5xl lg:text-[3.5rem]" data-id="element-101" data-mp="1g7dpz7wnho6h">
            Have a Project in Mind?
            <br data-id="element-102" data-mp="16bss9lym7a2j" />
            <span className="text-cobalt-300" data-id="element-103" data-mp="sib9w4ho03e3">Let&rsquo;s Talk.</span>
          </h2>
          <p className="mt-7 max-w-xl text-lg leading-relaxed text-charcoal-200" data-id="element-104" data-mp="sg8d91m0bc0e">
            Tell us what your property needs and let our team help you find the
            right solution. Call or email us directly — you&rsquo;ll speak with
            the people who handle your project.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-105" data-mp="ngvmw6vxfmt2">
            <ButtonLink href={company.phoneHref} size="lg" data-id="element-106" data-mp="9k8os0s8mqlk">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="dlak46j1aii9" />
              Call {company.phoneDisplay}
            </ButtonLink>
            <ButtonLink href={directQuoteMailto} variant="outlineLight" size="lg" data-id="element-108" data-mp="2g90n27ws3sgw">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-109" data-mp="2bg7l1rsp2y8i" />
              Email Us Directly
            </ButtonLink>
          </div>

          <p className="mt-6 text-sm text-charcoal-400" data-id="element-110" data-mp="26fjsv2sqcbcp">
            Prefer a form?{' '}
            <a href="#contact" className="font-semibold text-white underline underline-offset-4 transition-colors duration-150 ease-out hover:text-cobalt-300" data-id="element-111" data-mp="21gqhbfx06uf6">
              Send your project details here
            </a>
            .
          </p>
        </Reveal>

        <Reveal delay={0.08} className="lg:pl-4" data-id="element-112" data-mp="2pa8lcpzaotaz">
          <ul className="divide-y divide-white/10 border-y border-white/10" data-id="element-113" data-mp="2l5r4ozo8ew4f">
            <li data-id="element-114" data-mp="1dtqpaqzm0sov">
              <a href={company.phoneHref} className="group flex items-center gap-5 py-6 transition-colors duration-150 ease-out" data-id="element-115" data-mp="1dua5o39m390s">
                <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-cobalt-700 text-white" aria-hidden="true" data-id="element-116" data-mp="3lfioyg3pe0hg">
                  <PhoneIcon className="h-5 w-5" data-id="element-117" data-mp="3uf5fg6uw9lvq" />
                </span>
                <span className="min-w-0" data-id="element-118" data-mp="30zp041tuwi1">
                  <span className="block text-xs font-bold uppercase tracking-[0.14em] text-charcoal-400" data-id="element-119" data-mp="321bd4oan5f2">
                    Call us
                  </span>
                  <span className="mt-1 block text-lg font-bold tracking-tight text-white transition-colors duration-150 ease-out group-hover:text-cobalt-300" data-id="element-120" data-mp="cz5oyg42psk9">
                    {company.phoneDisplay}
                  </span>
                </span>
                <ArrowRightIcon className="ml-auto h-5 w-5 shrink-0 text-charcoal-500 transition-transform duration-150 ease-out group-hover:translate-x-1 group-hover:text-white" aria-hidden="true" data-id="element-121" data-mp="lykhrm7pqf7x" />
              </a>
            </li>
            <li data-id="element-122" data-mp="1sg0phfe5g80e">
              <a href={company.emailHref} className="group flex items-center gap-5 py-6 transition-colors duration-150 ease-out" data-id="element-123" data-mp="1sfh57s1117j7">
                <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-cobalt-700 text-white" aria-hidden="true" data-id="element-124" data-mp="22e6pfrgeb42m">
                  <MailIcon className="h-5 w-5" data-id="element-125" data-mp="19rlxaos3iny0" />
                </span>
                <span className="min-w-0" data-id="element-126" data-mp="14rprcjzu8mft">
                  <span className="block text-xs font-bold uppercase tracking-[0.14em] text-charcoal-400" data-id="element-127" data-mp="14t0xgqgra6a3">
                    Email us
                  </span>
                  <span className="mt-1 block break-all text-lg font-bold tracking-tight text-white transition-colors duration-150 ease-out group-hover:text-cobalt-300" data-id="element-128" data-mp="1ep3x9po4xstv">
                    {company.email}
                  </span>
                </span>
                <ArrowRightIcon className="ml-auto h-5 w-5 shrink-0 text-charcoal-500 transition-transform duration-150 ease-out group-hover:translate-x-1 group-hover:text-white" aria-hidden="true" data-id="element-129" data-mp="m0q1zhoflam0" />
              </a>
            </li>
            <li className="py-6" data-id="element-130" data-mp="2nrqj9ptv8arx">
              <span className="block text-xs font-bold uppercase tracking-[0.14em] text-charcoal-400" data-id="element-131" data-mp="2sp8g4hulyzjk">
                Service area
              </span>
              <span className="mt-1 block text-lg font-bold tracking-tight text-white" data-id="element-132" data-mp="3gg4ejxtkkszs">
                Orlando &amp; Central Florida
              </span>
            </li>
          </ul>
        </Reveal>
      </div>
    </section>;
}